import { render } from "./Contributions.vue?vue&type=template&id=13c818a9&ts=true"
import script from "./Contributions.vue?vue&type=script&lang=ts"
export * from "./Contributions.vue?vue&type=script&lang=ts"

import exportComponent from "/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__